/* SuperDokan: progressive enhancement, original Shopify product form retained. */
(function () {
  'use strict';
  if (window.SDProductTrustLoaded) return;
  window.SDProductTrustLoaded = true;
  var copy = {
    en: {available:'Available to order',sold:'Sold out in this selection',invalid:'This combination is unavailable. Choose another option.',selected:'Your selection: ',choose:'Choose options',feedback:'Customer feedback',reviews:'reviews',singleReview:'review',ask:'Hi! I have a question about ',quantity:'Enter a whole-number quantity of 1 or more.',loading:'Updating…'},
    ar: {available:'متاح للطلب',sold:'هذا الخيار غير متوفر',invalid:'هالخيارات مش متوفرة سوا. اختَر خيار تاني.',selected:'اختيارك: ',choose:'اختَر الخيارات',feedback:'آراء العملاء',reviews:'تقييمات',singleReview:'تقييم',ask:'مرحبا! عندي سؤال عن ',quantity:'أدخل كمية صحيحة من قطعة واحدة أو أكثر.',loading:'جارٍ التحديث…'}
  };
  function setText(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  function visible(node) { return !!(node && node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'); }
  function cleanClone(source) {
    var clone = source.cloneNode(true);
    clone.querySelectorAll('script,style,iframe,object,embed,form,template').forEach(function (n) { n.remove(); });
    [clone].concat(Array.from(clone.querySelectorAll('*'))).forEach(function (n) {
      n.removeAttribute('id');
      Array.from(n.attributes).forEach(function (a) { if (/^on/i.test(a.name)) n.removeAttribute(a.name); });
    });
    var fragment = document.createDocumentFragment();
    while (clone.firstChild) fragment.appendChild(clone.firstChild);
    return fragment;
  }
  function init() {
    var source = document.getElementById('sd-product-trust-template');
    var root = document.querySelector('#PageContainer .ptContainer[data-section-type="product"]');
    if (!source || !root || root.dataset.sdPdp) return;
    var sectionId = root.dataset.sectionId;
    var master = root.querySelector('[id="ProductSelect-' + sectionId + '"]');
    var form = master && master.closest('form');
    var mainButton = form && form.querySelector('.product-action button[name="add"]');
    var data = document.getElementById('ProductJson-' + sectionId);
    var title = root.querySelector('.product-single__title');
    if (!form || !mainButton || !data || !title) return;
    var product;
    try { product = JSON.parse(data.textContent); } catch (_) { return; }
    if (!product || String(product.id) !== source.dataset.productId || !Array.isArray(product.variants)) return;
    var text = copy[source.dataset.language] || copy.en;
    var pageURL = new URL(source.dataset.url);
    if (/^https?:$/.test(location.protocol)) pageURL = new URL(location.origin + location.pathname);
    var fragment = source.content.cloneNode(true);
    var jumps = fragment.querySelector('.sd-pdp-jumps');
    var selection = fragment.querySelector('.sd-pdp-selection');
    var confidence = fragment.querySelector('.sd-pdp-confidence');
    var guide = fragment.querySelector('.sd-pdp-size-guide');
    var rail = fragment.querySelector('.sd-pdp-rail');
    var railAction = rail.querySelector('[data-sd-rail-action]');
    var actions = mainButton.closest('.product-action');
    title.after(jumps);
    actions.before(guide, selection);
    actions.after(confidence);
    document.body.appendChild(rail);
    root.dataset.sdPdp = '1';
    document.body.classList.add('sd-pdp-enhanced');
    var lang = source.dataset.language;
    if (lang === 'ar') {confidence.dir='rtl';selection.dir='rtl';jumps.dir='rtl';guide.dir='rtl';rail.dir='rtl';}
    var removers = [], observers = [], frame = 0, railFrame = 0, busy = false;
    var explicitChoice = new URL(location.href).searchParams.has('variant');
    var totalVariantCount = Number(source.dataset.variantCount || product.variants.length);
    var completeData = totalVariantCount <= product.variants.length;
    var hasOptions = !product.variants.every(function (v) { return v.title === 'Default Title'; });
    var quantity = form.querySelector('input[name="quantity"]');
    if (quantity) {
      quantity.setAttribute('inputmode','numeric');quantity.setAttribute('pattern','[0-9]*');quantity.setAttribute('min','1');
      if (!quantity.hasAttribute('aria-label')) quantity.setAttribute('aria-label',lang==='ar'?'الكمية':'Quantity');
    }
    function listen(node, event, fn, options) {
      node.addEventListener(event, fn, options);
      removers.push(function () {node.removeEventListener(event, fn, options);});
    }
    function observe(node, fn, options) {
      if (!node) return null;
      var observer = new MutationObserver(fn);observer.observe(node,options);observers.push(observer);return observer;
    }
    function selectors() { return Array.from(form.querySelectorAll('select.single-option-selector')); }
    function selectedVariant() {
      var inputs = selectors();
      if (inputs.length) return product.variants.find(function (v) {
        return Array.isArray(v.options) && v.options.length === inputs.length && inputs.every(function (s,i) {
          var match=(s.dataset.index||'').match(/^option([1-3])$/);return String(v.options[match?Number(match[1])-1:i])===s.value;
        });
      }) || null;
      return product.variants.find(function (v) {return String(v.id)===master.value;}) || (product.variants.length===1?product.variants[0]:null);
    }
    function selectionText(v) {
      if (!hasOptions) return '';
      var inputs=selectors();
      if (inputs.length) return inputs.map(function (s,i) {
        var name=product.options[i];if (name && typeof name==='object') name=name.name;
        return (name || (i+1))+': '+s.value;
      }).join(' / ');
      return v ? v.title : '';
    }
    function updateSwatches() {
      if (!completeData) return;
      var inputs=selectors();
      form.querySelectorAll('.swatch[data-option-index]').forEach(function (group) {
        var index=Number(group.dataset.optionIndex);
        var name=product.options[index];if(name && typeof name==='object')name=name.name;
        group.setAttribute('role','group');group.setAttribute('aria-label',String(name || 'Options'));
        group.querySelectorAll('input.swatchInput').forEach(function (radio) {
          var available=product.variants.some(function (v) {
            return v.available && String(v.options[index])===radio.value && inputs.slice(0,index).every(function (s,i) {return String(v.options[i])===s.value;});
          });
          radio.disabled=!available;radio.setAttribute('aria-label',radio.value);
          var element=radio.closest('.swatch-element');if(element)element.classList.toggle('soldout',!available);
        });
      });
    }
    function scrollToElement(element) {
      if (!element) return;
      var y=window.scrollY+element.getBoundingClientRect().top-100;
      window.scrollTo({top:Math.max(0,y),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      element.setAttribute('tabindex','-1');element.focus({preventScroll:true});
    }
    function findTab(pattern) {
      var link=Array.from(root.querySelectorAll('.tablink')).find(function (a) {return pattern.test(a.textContent);});
      if(!link)return null;
      var target=document.getElementById((link.getAttribute('href')||'').slice(1));
      return target && root.contains(target)?{link:link,target:target}:null;
    }
    var detailsTab=findTab(/product details|description|تفاصيل|وصف/i);
    var detailsButton=jumps.querySelector('[data-sd-details]');
    if(detailsTab){detailsButton.hidden=false;listen(detailsButton,'click',function(){detailsTab.link.click();scrollToElement(detailsTab.target);});}
    var policyTab=findTab(/shipping|delivery|returns|الشحن|التوصيل|الإرجاع|الاسترجاع/i);
    var delivery=confidence.querySelector('.sd-pdp-delivery');
    var policyLinks=confidence.querySelector('.sd-pdp-policy-links');
    if(policyTab && policyTab.target.textContent.trim()){
      delivery.querySelector('.sd-pdp-policy-body').appendChild(cleanClone(policyTab.target));delivery.hidden=false;
      // Copy a delivery line only when it exists verbatim in this market's content.
      var range=policyTab.target.textContent.match(/For deliveries within Lebanon, estimated delivery is 2[–-]5 business days from order placement, including processing\./i);
      if(range && source.dataset.country==='LB' && lang!=='ar')setText(confidence.querySelector('[data-sd-delivery-summary]'),'Lebanon: estimated 2–5 business days, including processing.');
    }
    if(policyLinks.children.length){policyLinks.hidden=false;}
    policyLinks.querySelectorAll('a[data-sd-policy-link]').forEach(function (a) {
      var url=new URL(a.getAttribute('href'),pageURL.origin),prefix=(source.dataset.rootUrl||'/').replace(/\/$/,'');
      if(url.origin===pageURL.origin && /^\/policies\//.test(url.pathname))a.setAttribute('href',prefix+url.pathname);
    });
    var chart=document.getElementById('sizechart');
    var hasSize=product.options.some(function (name) {return /size|مقاس|قياس|taille/i.test(typeof name==='object'?name.name:name);});
    if(hasSize && chart && (chart.textContent.trim() || chart.querySelector('img'))){guide.querySelector('.sd-pdp-guide-body').appendChild(cleanClone(chart));guide.hidden=false;}
    var help=confidence.querySelector('.sd-pdp-help');
    if(help && !/^\d{7,15}$/.test(source.dataset.whatsapp||'')){help.remove();help=null;}
    if(delivery.hidden && policyLinks.hidden && !help)confidence.hidden=true;
    var reviewButton=jumps.querySelector('[data-sd-reviews]');
    var reviewTarget=null;
    function connectReviews(){
      var candidates=Array.from(document.querySelectorAll('.jdgm-review-widget,#judgeme_product_reviews'));
      reviewTarget=candidates.find(function(n){var id=n.dataset.productId||n.dataset.id;return !id || id===String(product.id);}) || null;
      if(!reviewTarget)return false;
      var count=Number(source.dataset.reviewCount),rating=Number(source.dataset.rating),max=Number(source.dataset.ratingMax);
      if(!(count>0 && rating>0 && max>=rating)){
        var badge=fragment.querySelector('[data-sd-review-badge]');
        badge=badge && badge.content.querySelector('[data-number-of-reviews][data-average-rating]');
        count=badge?Number(badge.dataset.numberOfReviews):0;rating=badge?Number(badge.dataset.averageRating):0;max=5;
      }
      var label=text.feedback;
      if(Number.isInteger(count) && count>0 && rating>0 && rating<=max && max>0){label='★ '+rating.toFixed(1)+'/'+max+' · '+count+' '+(count===1?text.singleReview:text.reviews);}
      setText(reviewButton,label);reviewButton.hidden=false;return true;
    }
    listen(reviewButton,'click',function(){scrollToElement(reviewTarget);});
    var reviewObserver=null;
    if(!connectReviews())reviewObserver=observe(document.getElementById('PageContainer'),function(){if(connectReviews() && reviewObserver)reviewObserver.disconnect();},{childList:true,subtree:true});
    var reviewTimer=setTimeout(function(){if(reviewObserver)reviewObserver.disconnect();},15000);
    var price=root.querySelector('.product-single__price');
    var basePrice=root.querySelector('[id="ProductPrice-'+sectionId+'"]');
    var finalPrice=root.querySelector('[id="ProductPriceFinal-'+sectionId+'"]');
    function update(){
      frame=0;if(!root.isConnected)return;
      var v=selectedVariant(),selected=selectionText(v),valid=!!(v && v.available);
      selection.dataset.unavailable=completeData && !valid?'true':'false';
      setText(selection.querySelector('[data-sd-availability]'),!completeData?'':v?(valid?text.available:text.sold):text.invalid);
      setText(selection.querySelector('[data-sd-selection]'),selected?text.selected+selected:'');
      setText(rail.querySelector('[data-sd-rail-selection]'),selected);
      var displayed=finalPrice && visible(finalPrice)?finalPrice:basePrice;
      setText(rail.querySelector('[data-sd-rail-price]'),displayed && (v || !completeData)?displayed.textContent.trim():'');
      updateSwatches();
      var choose=!completeData || (hasOptions && !explicitChoice) || !valid;
      setText(railAction,busy?text.loading:choose?text.choose:mainButton.textContent.trim());
      railAction.disabled=busy || (!choose && mainButton.disabled);
      if(help){
        var link=new URL(pageURL.href);if(v)link.searchParams.set('variant',String(v.id));
        var message=text.ask+source.dataset.title+(selected?' — '+selected:'')+'\n'+link.href;
        help.href='https://wa.me/'+source.dataset.whatsapp+'?text='+encodeURIComponent(message);
      }
      updateRail();
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    function updateRail(){
      var blocked=document.body.matches('.menuOn,.showOverly,.loading') || !!document.querySelector('#cart-drawer.active,#searchPopup.active,.mfp-wrap,.pswp--open,dialog[open]');
      var focused=document.activeElement;
      var keyboard=focused && /INPUT|TEXTAREA|SELECT/.test(focused.tagName);
      var show=matchMedia('(max-width:766px)').matches && mainButton.getBoundingClientRect().bottom<0 && !blocked && !keyboard;
      if(rail.hidden===show)rail.hidden=!show;
      if(document.body.classList.contains('sd-pdp-has-rail')!==show)document.body.classList.toggle('sd-pdp-has-rail',show);
    }
    function onChoice(event){
      if(event.target.matches('.single-option-selector,.swatchInput,select[name="id"]'))explicitChoice=true;
      if(quantity)quantity.setCustomValidity('');schedule();
    }
    listen(form,'change',onChoice);
    function guardQuantity(event){
      var fromButton=event.type==='submit' || event.target===mainButton || mainButton.contains(event.target);
      if(!fromButton)return;
      var v=selectedVariant();
      if(completeData && (!v || !v.available)){
        event.preventDefault();event.stopImmediatePropagation();scrollToElement(selection);return;
      }
      if(quantity && (!/^\d+$/.test(quantity.value.trim()) || Number(quantity.value)<1 || !Number.isSafeInteger(Number(quantity.value)))){
        event.preventDefault();event.stopImmediatePropagation();quantity.setCustomValidity(text.quantity);quantity.reportValidity();quantity.focus();
      }
    }
    listen(form,'click',guardQuantity,true);listen(form,'touchend',guardQuantity,true);listen(form,'submit',guardQuantity,true);
    listen(railAction,'click',function(){
      var v=selectedVariant();
      if(!completeData || !v || !v.available || (hasOptions && !explicitChoice)){
        var target=Array.from(form.querySelectorAll('.swatch,.selector-wrapper')).find(visible) || selection;scrollToElement(target);return;
      }
      if(!busy && !mainButton.disabled)mainButton.click();
    });
    observe(price,schedule,{childList:true,subtree:true,characterData:true});
    observe(mainButton,schedule,{attributes:true,attributeFilter:['disabled'],childList:true,subtree:true,characterData:true});
    observe(document.body,updateRail,{attributes:true,attributeFilter:['class']});
    ['cart-drawer','searchPopup'].forEach(function(id){observe(document.getElementById(id),updateRail,{attributes:true,attributeFilter:['class']});});
    function scheduleRail(){if(!railFrame)railFrame=requestAnimationFrame(function(){railFrame=0;updateRail();});}
    listen(window,'scroll',scheduleRail,{passive:true});listen(window,'resize',scheduleRail,{passive:true});
    listen(document,'focusin',updateRail);listen(document,'focusout',schedule);
    if(window.jQuery){
      var ns='.sdPdp'+sectionId.replace(/[^a-z0-9]/gi,'');
      window.jQuery(root).on('variantChange'+ns,schedule);
      window.jQuery(document).on('cart.requestStarted'+ns,function(){busy=true;schedule();}).on('cart.requestComplete'+ns,function(){busy=false;schedule();});
      removers.push(function(){window.jQuery(root).off(ns);window.jQuery(document).off(ns);});
    }
    root.sdPdpDispose=function(){
      cancelAnimationFrame(frame);cancelAnimationFrame(railFrame);clearTimeout(reviewTimer);observers.forEach(function(o){o.disconnect();});removers.forEach(function(f){f();});
      [jumps,guide,selection,confidence,rail].forEach(function(n){n.remove();});delete root.dataset.sdPdp;document.body.classList.remove('sd-pdp-has-rail','sd-pdp-enhanced');
    };
    update();
  }
  function ready(){setTimeout(init,0);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ready,{once:true});else ready();
  window.addEventListener('load',ready,{once:true});
  document.addEventListener('shopify:section:load',ready);
  document.addEventListener('shopify:section:unload',function(event){event.target.querySelectorAll('[data-sd-pdp]').forEach(function(root){if(root.sdPdpDispose)root.sdPdpDispose();});});
})();
